module.exports = __webpack_public_path__ + "media/images/pear_5-44e5fda0306a358737628c24d70adcf8.jpg";